var _title;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogoVerticalForWhiteBackground = function SvgLogoVerticalForWhiteBackground(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 1920 416",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "logo")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M63.25,139.68h-11A50.49,50.49,0,0,0,1.72,190.17V341.64a50.5,50.5,0,0,0,50.49,50.49h11a50.49,50.49,0,0,0,50.49-50.49V190.17A50.48,50.48,0,0,0,63.25,139.68Z",
    style: {
      fill: "#ffab00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.72-.36H192.1a50.49,50.49,0,0,0-50.5,50.49V61.21a50.5,50.5,0,0,0,50.5,50.49H343.72a50.5,50.5,0,0,0,50.49-50.49V50.13A50.49,50.49,0,0,0,343.72-.36Z",
    style: {
      fill: "#2979ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.48-.36H52.21A50.49,50.49,0,0,0,1.72,50.13V61.39a50.49,50.49,0,0,0,50.49,50.49H63.48A50.49,50.49,0,0,0,114,61.39V50.13A50.49,50.49,0,0,0,63.48-.36Z",
    style: {
      fill: "#f80046"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.6,
    y: 139.68,
    width: 252.45,
    height: 252.45,
    rx: 50.49,
    style: {
      fill: "#00cc3e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.56,171.42c-31-7.26-53.64-12.91-53.64-31.06,0-16.13,13.71-27.42,39.53-27.42a116.77,116.77,0,0,1,64.18,19.3,17.27,17.27,0,0,0,23.43-3.79l11.17-14.71a17.29,17.29,0,0,0-3.92-24.62c-24.61-17.23-55.2-26.2-90.83-26.2-63.32,0-102,36.3-102,81.07,0,60.09,56.46,72.19,100.43,82.28,31,7.26,54.44,14.11,54.44,34.28,0,15.33-15.32,30.25-46.78,30.25a117.73,117.73,0,0,1-72.38-24.54,17.15,17.15,0,0,0-24.29,3.7l-11.17,15.47A17.19,17.19,0,0,0,510,309c24.62,19.3,58,31.78,101.75,31.78,72.6,0,107.69-37.11,107.69-86.31C719.39,194.81,662.93,181.5,618.56,171.42Z",
    style: {
      fill: "#1c272c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.35,136.33c-31.87,0-56.06,15.32-68.57,30.25V84.19A17.22,17.22,0,0,0,771.55,67H754.79a17.23,17.23,0,0,0-17.23,17.23V318.74A17.23,17.23,0,0,0,754.79,336h16.76a17.22,17.22,0,0,0,17.23-17.23V204.89c8.88-11.69,24.6-23,44.37-23,22.18,0,36.3,8.47,36.3,35.49V318.74A17.22,17.22,0,0,0,886.68,336h16.76a17.23,17.23,0,0,0,17.23-17.23V197.63C920.67,159.72,900.1,136.33,857.35,136.33Z",
    style: {
      fill: "#1c272c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.51,136.33c-59.28,0-100.82,45.57-100.82,102,0,62.51,44.76,102.44,104,102.44,26,0,52.38-6.88,71.56-20.11a11.24,11.24,0,0,0,2.77-15.59l-9.89-14.49a11.33,11.33,0,0,0-15.5-3.08,84.17,84.17,0,0,1-43.29,12.53c-33.07,0-52.84-20.57-56.06-45.17h133.49a11.29,11.29,0,0,0,11.3-11.29C1349.12,179.89,1309.59,136.33,1251.51,136.33Zm-48,83.89c2.42-19.36,16.13-43.16,48-43.16,33.88,0,46.79,24.61,48,43.16Z",
    style: {
      fill: "#1c272c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1479.47,299.66a8.57,8.57,0,0,0-10.77-5.9,34.29,34.29,0,0,1-9.8,1.47c-11.3,0-17.75-9.27-17.75-21.37V185.94h22.3a17.24,17.24,0,0,0,17.23-17.23V158.4a17.23,17.23,0,0,0-17.23-17.23h-22.3v-36a17.22,17.22,0,0,0-17.23-17.23h-17.16a17.22,17.22,0,0,0-17.23,17.23v36h-15a17.23,17.23,0,0,0-17.23,17.23v10.31a17.24,17.24,0,0,0,17.23,17.23h15V287.57c0,34.69,19.36,53.24,55.25,53.24,17,0,29.12-3.56,37.24-8.46a8.66,8.66,0,0,0,3.9-9.76Z",
    style: {
      fill: "#1c272c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1676.26,141.17h-17.17a17.23,17.23,0,0,0-17.23,17.23v7.77c-15.73-19.76-36.7-29.84-60.09-29.84-49.21,0-85.91,35.49-85.91,99.21,0,64.94,37.11,99.22,85.91,99.22,23.79,0,44.77-11.29,60.09-30.65v19.76c0,38.31-29,49.2-53.64,49.2-21,0-39-5-53.6-17.17a8.62,8.62,0,0,0-12.89,2l-13.42,21.65a8.64,8.64,0,0,0,2,11.36c22.82,17.64,47.12,24.11,77.88,24.11,48,0,105.27-18.15,105.27-92.36V158.4A17.23,17.23,0,0,0,1676.26,141.17Zm-78.36,148c-29,0-49.2-20.16-49.2-53.64s20.16-53.64,49.2-53.64c32.33,0,49.24,24.07,49.24,53.64C1647.14,271.69,1624.53,289.18,1597.9,289.18Z",
    style: {
      fill: "#1c272c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1815.75,136.33c-64.13,0-102.84,46.78-102.84,102,0,55.65,38.71,102.44,102.84,102.44,64.53,0,103.25-46.79,103.25-102.44C1919,183.11,1880.28,136.33,1815.75,136.33Zm0,158.9c-31.86,0-49.61-26.21-49.61-56.86,0-30.25,17.75-56.47,49.61-56.47s50,26.22,50,56.47C1865.76,269,1847.61,295.23,1815.75,295.23Z",
    style: {
      fill: "#1c272c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1041.3,136.33c-59.29,0-100.83,45.57-100.83,102,0,62.51,44.77,102.44,104.06,102.44,26,0,52.38-6.88,71.55-20.11a11.25,11.25,0,0,0,2.78-15.59l-9.9-14.49a11.32,11.32,0,0,0-15.49-3.08,84.21,84.21,0,0,1-43.3,12.53c-33.07,0-52.83-20.57-56.06-45.17h133.5a11.28,11.28,0,0,0,11.29-11.29C1138.9,179.89,1099.38,136.33,1041.3,136.33Zm-48,83.89c2.42-19.36,16.14-43.16,48-43.16,33.88,0,46.78,24.61,48,43.16Z",
    style: {
      fill: "#1c272c"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoVerticalForWhiteBackground, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo_vertical-for-white-background.e0bd79cb.svg";
export { ForwardRef as ReactComponent };